export const autofocus = {
  mounted(el) {
    // Check there isn't already an autofocused element
    if (document.querySelector("[data-focused]")) return;

    let item = null;

    if (el.tagName == "INPUT" || el.tagName == "TEXTAREA") item = el;

    if (
      el.getElementsByTagName("INPUT").length &&
      el.getElementsByTagName("INPUT")[0].getAttribute("type") != "file"
    )
      item = el.getElementsByTagName("INPUT")[0];
    else if (el.getElementsByTagName("TEXTAREA").length)
      item = el.getElementsByTagName("TEXTAREA")[0];

    if (item) {
      item.setAttribute("data-focused", true);
      item.focus();
      if (item.type != "email") item.setSelectionRange(-1, -1);
    }
  }
};
